import { CommonModule, CurrencyPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
// import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';

import { AppLoadModule } from '@fry/lib/appload';
import { ConfigModule } from '@fry/lib/config';
import { AuthModule } from '@fry/lib/auth';
import { LayoutModule } from '@fry/components/layout/layout.module';
import { FryCommonModule } from '@fry/components/common';
import { MenuService, RemoteMenuService } from '@fry/lib/menu';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '@fry/components/material';
import { EasFormModule } from '@fry/components/common/easform/easform.module';
import { BookingWorkflowModule } from '@fry/booking/lib/bookings/workflow/workflow.module';

import { PERMISSIONS, PermissionsModule } from '@fry/lib/permissions';
import { userPermissions } from '@fry/lib/users';
import { rolesPermissions } from '@fry/lib/roles';
import { userFieldPermissions } from '@fry/lib/user-fields';
import { bookingTypePermissions } from '@fry/booking/lib';
import { bookingItemsPermissions } from '@fry/booking/lib/booking-items';
import { venuesPermissions } from '@fry/booking/lib/venues';
import { BookingInfo, bookingsPermissions } from '@fry/booking/lib/bookings';
import { paymentsPermissions } from '@fry/payments/lib';
import { TYPE_INFO } from '@fry/lib/store';
import { PaymentMethodInfo } from '@fry/payments/lib/payment_method.info';
import { TransactionInfo } from '@fry/payments/lib/transaction.info';

import { ErrorModule } from '@fry/lib/error';
import { eligibilityPermissions } from '@fry/booking/lib/eligibility';
import { translationPermissions } from '@fry/booking/lib/translation';
import { ASYNC_CONFIG, AsyncConfig } from '@fry/async-tasks/app/async_config';
import { BookingPreviewComponent } from '@fry/booking/components/bookings/booking-preview/booking-preview.component';
import { COLUMN_MODAL } from '@fry/components/common/table/table.component';
import { EmailPreviewComponent } from '@fry/components/email';
import { dashboardsPermissions } from '@fry/dashboards/lib/dashboards.permissions';
import { BookingMenu, BookingRemoteMenu } from '@fry/booking/app';
import { GeneralMenu } from '@fry/components/general';
import { EportfolioMenu } from '@fry/components/general/eportfolio.menu';
import { RolesMenu } from '@fry/components/roles';
import { UsersFieldsMenu } from '@fry/components/user-fields';
import { UsersMenu, UsersRemoteMenu } from '@fry/components/users';
import { DashboardMenu } from '@fry/dashboards/lib/dashboard.menu';
import { PaymentsMenu } from '@fry/payments/components';
import { BookingApplyModalComponent } from '@fry/booking/components/bookings/booking-available-card/booking-available-apply.component';
import { AsyncTaskUndoModalComponent } from '@fry/async-tasks/components/async-task-undo-modal/async-task-undo-modal.component';
import { provideFieldExpanders } from '@fry-it/risr-features/common';
import { provideRisrCoreConfig } from '@fry-it/risr-core';

const async_config: AsyncConfig = {
  id: 'wizard-booking'
}

// This cannot be any clever, it has to be a single constant for the AOT compiler to understand
const permissionProviders = [
  { provide: PERMISSIONS, multi: true, useValue: userPermissions },
  { provide: PERMISSIONS, multi: true, useValue: rolesPermissions },
  { provide: PERMISSIONS, multi: true, useValue: userFieldPermissions },
  { provide: PERMISSIONS, multi: true, useValue: bookingTypePermissions },
  { provide: PERMISSIONS, multi: true, useValue: bookingItemsPermissions },
  { provide: PERMISSIONS, multi: true, useValue: venuesPermissions },
  { provide: PERMISSIONS, multi: true, useValue: bookingsPermissions },
  { provide: PERMISSIONS, multi: true, useValue: paymentsPermissions },
  { provide: PERMISSIONS, multi: true, useValue: eligibilityPermissions },
  { provide: PERMISSIONS, multi: true, useValue: translationPermissions },
  { provide: PERMISSIONS, multi: true, useValue: dashboardsPermissions },
];

const searchProviders = [
  { provide: TYPE_INFO, multi: true, useClass: BookingInfo},
  { provide: TYPE_INFO, multi: true, useClass: PaymentMethodInfo},
  { provide: TYPE_INFO, multi: true, useClass: TransactionInfo},
];

const tableProviders = [
  { provide: COLUMN_MODAL, multi: true, useValue: { modalType: 'bookingPreview', component: BookingPreviewComponent }},
  { provide: COLUMN_MODAL, multi: true, useValue: { modalType: 'emailPreview', component: EmailPreviewComponent }},
  { provide: COLUMN_MODAL, multi: true, useValue: { modalType: 'bookingApply', component: BookingApplyModalComponent }},
  { provide: COLUMN_MODAL, multi: true, useValue: { modalType: 'asyncTaskUndo', component: AsyncTaskUndoModalComponent }},
];

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [AppLoadModule.forRoot(),
        PermissionsModule.forRoot(permissionProviders),
        CommonModule,
        BrowserModule,
        RouterModule,
        MaterialModule,
        FryCommonModule,
        LayoutModule,
        AuthModule.forRoot(),
        ConfigModule.forRoot(environment),
        AppRoutingModule,
        // ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
        BrowserAnimationsModule,
        EasFormModule,
        BookingWorkflowModule.forRoot(),
        ErrorModule], providers: [
        CurrencyPipe,
        MenuService,
        UsersMenu,
        UsersRemoteMenu,
        UsersFieldsMenu,
        RolesMenu,
        DashboardMenu,
        BookingMenu,
        BookingRemoteMenu,
        EportfolioMenu,
        GeneralMenu,
        PaymentsMenu,
        { provide: RemoteMenuService, useClass: MenuService },
        { provide: ASYNC_CONFIG, useValue: async_config },
        ...searchProviders,
        ...tableProviders,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideFieldExpanders(),
        provideRisrCoreConfig({ product: 'eas' }),
    ] })
export class AppModule { }
